import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tooltip-text" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "tooltip-root",
  ref: "rootSlot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip-hover",
    onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mouseover && _ctx.mouseover(...args))),
    onMouseout: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseout && _ctx.mouseout(...args)))
  }, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.hover)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["tooltip-body", { fit: _ctx.fit, letter: _ctx.letter, transition: _ctx.transition }]),
            style: _normalizeStyle({ top: _ctx.top, left: _ctx.left, '--left': _ctx.leftVar }),
            ref: "tooltipBody"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "text", {}, undefined, true)
            ]),
            _createElementVNode("img", {
              src: require('../../assets/icons/tooltip.svg'),
              class: _normalizeClass(["tooltip-icon", { top: _ctx.iconTop }])
            }, null, 10, _hoisted_2)
          ], 6))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "root", {}, undefined, true)
    ], 512)
  ], 32))
}